module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./EquityView.js"));
	}, "EquityView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EquityView!./src/pages/Promote/Equity/EquityView.js
// module id = 2066
// module chunks = 367